import {
  EDITOR_LOTTERY_HEADER_HEIGHT_FALLBACK,
  EDITOR_LOTTERY_SCROLL_GAP,
} from '../constants/editor'

const STICKY_HEADER_SELECTOR = '[data-containerid="page_header"]'

export const getStickyHeaderHeight = () =>
  document.querySelector(STICKY_HEADER_SELECTOR)?.getBoundingClientRect().height ??
  EDITOR_LOTTERY_HEADER_HEIGHT_FALLBACK

export const getStickyHeaderSpace = () => getStickyHeaderHeight() + EDITOR_LOTTERY_SCROLL_GAP

export const getScrollTopBelowHeader = (element: HTMLElement) =>
  element.getBoundingClientRect().top + window.scrollY - getStickyHeaderSpace()
